/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Servers_Field_Client_Id_Keep_HintInputs */



/**
* | output |
* | --- |
* | "Leave empty to keep the current client." |
*
* @param {Mcp_Servers_Field_Client_Id_Keep_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_field_client_id_keep_hint = /** @type {((inputs?: Mcp_Servers_Field_Client_Id_Keep_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_Field_Client_Id_Keep_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Leer lassen, um den aktuellen Client zu behalten.")
	return /** @type {LocalizedString} */ ("Leave empty to keep the current client.")
});